import React, { useEffect } from "react";
import { useState } from "react";
import "../Styles/style.css";
import TimerLoader from "../../images/timer.gif";
import { Modal, Box, Button } from "@mui/material";
import axios from "axios";
import { baseUrl } from "../../api/ipconfig";
import car from "../../images/car copy.png";
import Rocket from "../../images/rocket.png";
import SeoMeta from "../meta";
import NumberLogin from "../loginModal/number";
import { AuthContext } from "../../context/AuthContext";
import { v4 as uuidv4 } from "uuid";
import FAQsQuestions from "../FAQs_Questions/FAQsQuestions";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";

const successModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  minHeight: "10%",
  maxHeight: "95%",
  height: "auto",
  overflowY: "scroll",
};

export default function UserSubscription() {
  const history = useHistory();
  const { user } = React.useContext(AuthContext);
  const token = localStorage.getItem("token");

  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [randomToken, setRandomToken] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [paymentResponse, setPaymentResponse] = useState({});
  const [error, setError] = useState("");
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openFaildModal, setOpenFaildModal] = useState(false);
  const [successIsOpen, setSuccessIsOpen] = useState(false);
  const amount = 1000;

  const faqData = [
    {
      question: "What is a car inspection?",
      answer:
        "A car inspection is a thorough evaluation of a vehicle’s condition, including its mechanical systems, safety features, and overall performance. It aims to identify any issues that may affect the car's safety, reliability, and functionality.",
    },
    {
      question: "In which cities is Famewheels Car Inspection available?",
      answer:
        "Famewheels offers comprehensive car inspections in Karachi. Our services are designed to ensure your vehicle adheres to the highest standards of safety and performance.",
    },
    {
      question: "What is checked during a vehicle inspection?",
      answer:
        "A car inspection typically involves a thorough review of the vehicle's various components and systems, including its engine, transmission, brakes, suspension, and electrical systems. The inspection usually takes between 50 minutes to 1 hour, depending on the extent of the check.",
    },
    {
      question: "What are the benefits of a pre-purchase car inspection?",
      answer:
        "A pre-purchase car inspection helps uncover potential issues and verifies the vehicle's condition before finalizing the purchase. This can prevent unexpected repair costs and ensure you are making an informed decision.",
    },
    {
      question: "What should I do if the inspection report reveals problems?",
      answer:
        "If the inspection report identifies issues, you should discuss repair options or negotiate a price adjustment with the seller. Alternatively, you may need to reconsider proceeding with the purchase if the problems are significant.",
    },
    {
      question: "Does the car inspection report have a validity period?",
      answer:
        "Yes, a car inspection report typically has a validity period, which generally ranges from 30 to 90 days. The condition of the vehicle may change over time, so it’s advisable to act within this period.",
    },
  ];

  const LoginOpen = () => {
    setIsOpen(true);
  };
  const LoginClose = () => {
    setIsOpen(false);
  };

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    //PayFast Parameters
    const responseCode = params.get("err_code");
    const responseMessage = params.get("err_msg");
    const responseAmount = params.get("transaction_amount");
    const responseTransactionId = params.get("transaction_id");
    const responseBasketId = params.get("basket_id");

    if (params?.size > 0) {
      if (
        responseCode === "000" ||
        responseCode === "200" ||
        responseCode === "121"
      ) {
        setSuccessIsOpen(true);
        setPaymentResponse({
          responseMessage,
          responseAmount,
          responseTransactionId,
          responseBasketId,
        });
        if (
          responseCode &&
          responseAmount &&
          responseTransactionId &&
          responseBasketId &&
          responseMessage
        ) {
          assignSubscription(
            responseAmount,
            responseTransactionId,
            responseBasketId
          );
        }

        setTimeout(() => {
          setSuccessIsOpen(false);
          history.push("/");
        }, 4000);
      } else if (
        responseCode === "002" ||
        responseCode === "001" ||
        responseCode === "97" ||
        responseCode === "106" ||
        responseCode === "3" ||
        responseCode === "14" ||
        responseCode === "54" ||
        responseCode === "13" ||
        responseCode === "126" ||
        responseCode === "75" ||
        responseCode === "14" ||
        responseCode === "15" ||
        responseCode === "42" ||
        responseCode === "423" ||
        responseCode === "41" ||
        responseCode === "801" ||
        responseCode === "802" ||
        responseCode === "803" ||
        responseCode === "804" ||
        responseCode === "805" ||
        responseCode === "806" ||
        responseCode === "807" ||
        responseCode === "808" ||
        responseCode === "809" ||
        responseCode === "810" ||
        responseCode === "811" ||
        responseCode === "812" ||
        responseCode === "813" ||
        responseCode === "850" ||
        responseCode === "851" ||
        responseCode === "79" ||
        responseCode === "901" ||
        responseCode === "9000"
      ) {
        setOpenFaildModal(true);

        setTimeout(() => {
          setOpenFaildModal(false);
          history.push("/user_subscribe");
        }, 4000);
      } else {
      }
    }
  }, [history]);

  const assignSubscription = async (responseTransactionId) => {
    try {
      await axios.get(`${baseUrl}/assignuserpackage`, {
        params: {
          user_id: user?.id,
          payment_method: "PayFast",
          security_deposit: amount,
          payment_token: responseTransactionId,
          description: "Website",
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const generateToken = () => {
    const newToken = uuidv4().replace(/-/g, "").slice(0, 12);
    setRandomToken(newToken);
    getAccessToken(newToken);
  };

  // useEffect(() => {
  //   if (user?.id) {

  //     if (randomToken === "") {
  //       generateToken();
  //     }
  //   }
  // }, [user?.id]);

  const getAccessToken = async (token) => {
    try {
      const response = await axios.get(`${baseUrl}/gettoken`, {
        params: {
          BASKET_ID: user?.id + "-" + token,
          CURRENCY_CODE: "PKR",
          TXNAMT: amount,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // setTokenResponse(response?.data);
      handlePayFastFormSubmit(response?.data, token);
    } catch (error) {
      console.error(error);
    }
  };

  const url = window.location.href;

  const handlePayFastFormSubmit = (data, token) => {
    const form = document.createElement("form");
    form.method = "POST";
    form.id = "PayFast_payment_form";
    form.name = "PayFast-payment-form";
    form.action =
      "https://ipg1.apps.net.pk/Ecommerce/api/Transaction/PostTransaction";

    const CURRENCYCODE = document.createElement("input");
    CURRENCYCODE.type = "hidden";
    CURRENCYCODE.name = "CURRENCY_CODE";
    CURRENCYCODE.value = "PKR";
    form.appendChild(CURRENCYCODE);

    const MERCHANTID = document.createElement("input");
    MERCHANTID.type = "hidden";
    MERCHANTID.name = "MERCHANT_ID";
    MERCHANTID.value = 20579;
    form.appendChild(MERCHANTID);

    const MERCHANTNAME = document.createElement("input");
    MERCHANTNAME.type = "hidden";
    MERCHANTNAME.name = "MERCHANT_NAME";
    MERCHANTNAME.value = "FameWheels";
    form.appendChild(MERCHANTNAME);

    const ACCESSTOKEN = document.createElement("input");
    ACCESSTOKEN.type = "hidden";
    ACCESSTOKEN.name = "TOKEN";
    ACCESSTOKEN.value = data?.ACCESS_TOKEN;
    form.appendChild(ACCESSTOKEN);

    const BASKETID = document.createElement("input");
    BASKETID.type = "hidden";
    BASKETID.name = "BASKET_ID";
    BASKETID.value = user?.id + "-" + token;
    form.appendChild(BASKETID);

    const TXNAMTInput = document.createElement("input");
    TXNAMTInput.type = "hidden";
    TXNAMTInput.name = "TXNAMT";
    TXNAMTInput.value = amount;
    form.appendChild(TXNAMTInput);

    const ORDERDATE = document.createElement("input");
    ORDERDATE.type = "hidden";
    ORDERDATE.name = "ORDER_DATE";
    ORDERDATE.value = data?.GENERATED_DATE_TIME;
    form.appendChild(ORDERDATE);

    const SUCCESSURL = document.createElement("input");
    SUCCESSURL.type = "hidden";
    SUCCESSURL.name = "SUCCESS_URL";
    SUCCESSURL.value = `${url}`;
    form.appendChild(SUCCESSURL);

    const FAILUREURL = document.createElement("input");
    FAILUREURL.type = "hidden";
    FAILUREURL.name = "FAILURE_URL";
    FAILUREURL.value = `${url}`;
    form.appendChild(FAILUREURL);

    const CHECKOUTURL = document.createElement("input");
    CHECKOUTURL.type = "hidden";
    CHECKOUTURL.name = "CHECKOUT_URL";
    CHECKOUTURL.value = "https://www.famewheels.com/";
    form.appendChild(CHECKOUTURL);

    const CUSTOMEREMAIL = document.createElement("input");
    CUSTOMEREMAIL.type = "hidden";
    CUSTOMEREMAIL.name = "CUSTOMER_EMAIL_ADDRESS";
    CUSTOMEREMAIL.value = user?.email;
    form.appendChild(CUSTOMEREMAIL);

    const CUSTOMERMOBILENO = document.createElement("input");
    CUSTOMERMOBILENO.type = "hidden";
    CUSTOMERMOBILENO.name = "CUSTOMER_MOBILE_NO";
    CUSTOMERMOBILENO.value = user?.phone;
    form.appendChild(CUSTOMERMOBILENO);

    const SOMERANDOMSTRING = document.createElement("input");
    SOMERANDOMSTRING.type = "hidden";
    SOMERANDOMSTRING.name = "SIGNATURE";
    SOMERANDOMSTRING.value = "SOMERANDOM-STRING";
    form.appendChild(SOMERANDOMSTRING);

    const MERCHANTCART = document.createElement("input");
    MERCHANTCART.type = "hidden";
    MERCHANTCART.name = "VERSION";
    MERCHANTCART.value = "MERCHANT-CART0.1";
    form.appendChild(MERCHANTCART);

    const TXNDESCInput = document.createElement("input");
    TXNDESCInput.type = "hidden";
    TXNDESCInput.name = "TXNDESC";
    TXNDESCInput.value = "Item Purchased from Cart";
    form.appendChild(TXNDESCInput);

    const PROCCODEInput = document.createElement("input");
    PROCCODEInput.type = "hidden";
    PROCCODEInput.name = "PROCCODE";
    PROCCODEInput.value = "00";
    form.appendChild(PROCCODEInput);

    const ECOMMPURCHASE = document.createElement("input");
    ECOMMPURCHASE.type = "hidden";
    ECOMMPURCHASE.name = "TRAN_TYPE";
    ECOMMPURCHASE.value = "ECOMM_PURCHASE";
    form.appendChild(ECOMMPURCHASE);

    const STOREID = document.createElement("input");
    STOREID.type = "hidden";
    STOREID.name = "STORE_ID";
    STOREID.value = "";
    form.appendChild(STOREID);

    const RECURRINGTXN = document.createElement("input");
    RECURRINGTXN.type = "hidden";
    RECURRINGTXN.name = "RECURRING_TXN";
    RECURRINGTXN.value = "true";
    form.appendChild(RECURRINGTXN);

    document.body.appendChild(form);
    form.submit();
  };

  useEffect(() => {
    if (!window.googletag) {
      console.error("Google Publisher Tag (GPT) is not loaded.");
      return;
    }

    window.googletag = window.googletag || { cmd: [] };

    window.googletag.cmd.push(() => {
      // Sell Through Live Bidding - Between Ad
      window.googletag
        .defineSlot(
          "/23203048013/SellthroughlivebiddingBetween728x90",
          [728, 90],
          "div-gpt-ad-1743151847783-0"
        )
        .addService(window.googletag.pubads());

      // Sell Through Live Bidding - Mobile Ad
      window.googletag
        .defineSlot(
          "/23203048013/Sell-Through-Live-Bidding/Sell-Through-Live-Bidding-Mobile",
          [
            [320, 100],
            [320, 250],
            [320, 50],
          ],
          "div-gpt-ad-1740123702655-0"
        )
        .addService(window.googletag.pubads());

      // Enable ads
      window.googletag.pubads().enableSingleRequest();
      window.googletag.enableServices();

      // Display ads
      window.googletag.display("div-gpt-ad-1743151847783-0"); // Between Ad
      window.googletag.display("div-gpt-ad-1740123702655-0"); // Mobile Ad
    });
  }, []);

  return (
    <>
      <SeoMeta
        title="Subscription | FameWheels"
        desc="Explore the new and used cars at the the car auction in Pakistan. Famewheels has provided a platform for live car bidding in which you can bid on your favorite car and also check Famewheels Auction cars in Karachi for reliable and affordable cars."
        url="upcomming"
      />
      {/* submitting modal */}

      <Modal
        open={isSubmitting}
        onClose={() => setIsSubmitting(false)}
        disableAutoFocus={true}
        className="timerModal"
      >
        <Box className="text-center successModal" sx={successModal}>
          <img
            className="modalLoaderImg"
            src={TimerLoader}
            alt="Loading..."
            srcSet=""
          />
        </Box>
      </Modal>
      <Modal open={openSuccessModal} disableAutoFocus={true}>
        <Box className="text-center successModal" sx={successModal}>
          <div className="text-center py-2">
            <h3 style={{ fontSize: 24, fontWeight: "700", color: "#20409a" }}>
              Request received successfully
            </h3>
            <p className="">
              Dear Customer,
              <br />
              Thank you for requesting for bidding, our customer support
              executive will contact you shortly. You can also reach us by call
              or whatsapp on 0300-1113263.
            </p>
            <h2>Have a Good Time!</h2>
          </div>
        </Box>
      </Modal>

      <div className=" bgSubscribeGradient pb-5 text-white    ">
        <div class="container mx-auto w-100 w-md-75">
          <div className="row">
            <div className="d-flex flex-row flex-nowrap align-items-center justify-content-center col-12 py-5">
              <div className="">
                <img src={Rocket} alt="RocketImg" className="img-fluid" />
              </div>

              <div>
                <h1 className="m-0 text-center text-md-start rocket-heading">
                  Supercharge Your Car Selling Experience- Limited Time Offer!
                </h1>
              </div>
            </div>
          </div>

          <div className="row">
            <div class="d-flex flex-column-reverse flex-md-row mx-md-auto gap-3 w-100 w-md-75">
              <div className="col-md-6 col-12">
                <h1 className="responsive-heading ms-2 ms-md-0">
                  Unlock Premium Benefits at Just Rs 1,000!
                </h1>

                <div className="d-flex gap-4  mt-5 align-content-center ">
                  <div
                    className=" rounded-circle  d-inline-flex align-items-center justify-content-center"
                    style={{
                      width: "60px",
                      backgroundColor: "#48ad48",
                      height: "50px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="cutom-padding"
                      style={{
                        color: "white",
                        fontSize: "30px",
                      }}
                    />
                  </div>

                  <div>
                    <h2 className="fs-3 fs-md-2 ">5 Featured Ads</h2>
                    <p className="fs-5 fs-md-2">
                      Boost visibility with top placement on listings - more
                      views, faster sales!
                    </p>
                  </div>
                </div>

                <div className="d-flex gap-4 align-content-center ">
                  <div
                    className=" rounded-circle d-inline-flex align-items-center justify-content-center"
                    style={{
                      width: "50px",
                      backgroundColor: "#48ad48",
                      height: "50px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="cutom-padding"
                      style={{
                        color: "white",
                        fontSize: "30px",
                      }}
                    />
                  </div>

                  <div>
                    <h2 className="fs-3 fs-md-2">10 Boosts</h2>
                    <p className="fs-5 fs-md-2">
                      Instantly refresh your listings to the top of search
                      results
                    </p>
                  </div>
                </div>

                <div className="text-center">
                  {user ? (
                    <button
                      className="custom-button px-3"
                      style={{
                        border: "none",
                        height: "auto",
                        borderRadius: "15px",
                        backgroundColor: "#9c1812",
                        color: "white",
                        fontSize: "15px",
                      }}
                      onClick={generateToken}
                    >
                      Subscribe
                    </button>
                  ) : (
                    <button
                      className="custom-button px-3"
                      style={{
                        border: "none",
                        height: "auto",
                        borderRadius: "15px",
                        backgroundColor: "#9c1812",
                        color: "white",
                        fontSize: "15px",
                      }}
                      onClick={LoginOpen}
                    >
                      Subscribe
                    </button>
                  )}
                </div>
              </div>

              <div className="col-md-6 col-12">
                <img className="my-0 py-0" src={car} alt="CarImage" srcset="" />
                <p
                  className="text-center fs-3 fs-md-2 my-0"
                  style={{ fontWeight: "bold" }}
                >
                  Original Price: <strike>Rs9,500</strike>
                </p>
                <p
                  className="fs-2 fs-md-2 text-center my-0"
                  style={{ fontWeight: "bold" }}
                >
                  You Pay:{" "}
                  <span style={{ color: " #fdd667" }}> Only Rs 1,000</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FAQsQuestions faqData={faqData} />

      <Modal
        open={isOpen}
        onClose={LoginClose}
        disableAutoFocus={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="Fw-popups"
      >
        <Box className="sm-modal p-3 p-md-4">
          <div className="modalBody_area  px-2 ">
            <NumberLogin />
          </div>
        </Box>
      </Modal>
      <Modal
        open={openSuccessModal}
        onClose={() => setOpenSuccessModal(false)}
        disableAutoFocus={true}
      >
        <Box className="text-center successModal" sx={successModal}>
          <div className="text-center py-2"></div>
          <p className="m-0 p-0">Wait, do not close this window.</p>
          <p className="pt-1">Redirecting to payment... </p>
        </Box>
      </Modal>
      <Modal
        open={successIsOpen}
        onClose={() => setSuccessIsOpen(false)}
        disableAutoFocus={true}
      >
        <Box className="text-center successModal" sx={successModal}>
          <h3>Success!</h3>
          <h5>Inspection Slot Booked.</h5>

          <p className="m-0 p-0">{paymentResponse?.responseMessage}</p>
          <p className="pt-1">We will contact you soon. Thank You!</p>
        </Box>
      </Modal>
      <Modal
        open={openFaildModal}
        onClose={() => setOpenFaildModal(false)}
        disableAutoFocus={true}
      >
        <Box className="text-center successModal" sx={successModal}>
          <div className="text-center py-2">
            <h2 className="color-secondary">Payment Canceled</h2>
          </div>
          <p className="m-0 p-0">{paymentResponse?.responseMessage}</p>
          <p className="pt-1">We will contact you soon. Thank You!</p>
        </Box>
      </Modal>
    </>
  );
}
